package com.evoapps.evoshift.observability

import kotlinx.browser.localStorage

private const val KEY = "evoshift.privacy"

/**
 * One localStorage entry, e.g. `crash=0;usage=1;asked=1`. Storage can be missing or throw (private
 * windows, blocked storage): then nothing is remembered and nothing is collected.
 */
actual fun platformConsentStore(): ConsentStore = object : ConsentStore {
    override fun load(): TelemetryConsent {
        val raw = runCatching { localStorage.getItem(KEY) }.getOrNull() ?: return TelemetryConsent()
        val values = raw.split(';').associate { it.substringBefore('=') to (it.substringAfter('=') == "1") }
        return TelemetryConsent(
            crashReports = values["crash"] == true,
            usageStats = values["usage"] == true,
            asked = values["asked"] == true
        )
    }

    override fun save(consent: TelemetryConsent) {
        fun bit(value: Boolean) = if (value) "1" else "0"
        runCatching {
            localStorage.setItem(KEY, "crash=${bit(consent.crashReports)};usage=${bit(consent.usageStats)};asked=${bit(consent.asked)}")
        }
    }
}
